// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Module, ModuleType, Note } from '../../../../../types/Model';
import { S } from './styles';
import { useIntl } from 'react-intl';

interface NoteTabProps {
  currentModule?: Module;
  notes?: Note[];
  noteError?: Error;
  handleCreateNote?: (message: string) => void;
  handleDeleteNote?: (noteId: string) => void;
  handleUpdateNote?: (noteId: string, message: string) => void;
  handleFetchNote?: () => void;
  handleSeek?: (seconds: number) => void;
  setPlaying?: (playing: boolean) => void;
}

const MAX_INPUT_MESSAGE_LENGTH = 1000;

interface DeleteNoteQueue {
  startCountTime: Date;
  noteId: string;
  waitingAPI: boolean;
}

const NoteTab: React.FC<NoteTabProps> = (props): JSX.Element => {
  const intl = useIntl();
  const {
    currentModule,
    notes,
    noteError,
    handleCreateNote,
    handleDeleteNote,
    handleUpdateNote,
    handleFetchNote,
    handleSeek,
    setPlaying,
  } = props;
  const [editingNote, setEditingNote] = useState('');
  const [deletingNotes, setDeletingNotes] = useState<DeleteNoteQueue[]>([]);
  const [inputMessage, setInputMessage] = useState<string>('');
  const [isMessageCountShow, setIsMessageCountShow] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // for resizeable input box
  useLayoutEffect(() => {
    if (!textareaRef.current) return;

    textareaRef.current.style.height = ''; // reset height
    textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'

    setIsMessageCountShow(
      textareaRef.current.scrollHeight > 30 // original height
    );
  }, [inputMessage]);

  const DELETE_TIMEOUT_SECONDS = 5;

  useEffect(() => {
    if (deletingNotes.length > 0) {
      // console.log('Deleting note:', { deletingNotes });
      const timer = setInterval(() => {
        const currentTime = new Date();
        deletingNotes.forEach((deletingNote) => {
          if (currentTime.getTime() - deletingNote.startCountTime.getTime() > DELETE_TIMEOUT_SECONDS * 1000 && !deletingNote.waitingAPI) {
            // console.log('TIME TO DELETE', { deletingNote, timeout: currentTime.getTime() - deletingNote.startCountTime.getTime() })
            handleDeleteNote && handleDeleteNote(deletingNote.noteId);
            deletingNote.waitingAPI = true;
          }
        })
      }, 1000)

      return () => clearInterval(timer);
    }
  }, [deletingNotes]);

  useEffect(() => {
    setDeletingNotes(deletingNotes.filter((deletingNote) =>
      notes && notes.map((note) => note.id).indexOf(deletingNote.noteId) !== -1
    ))
  }, [notes]);

  const handleCreate = () => {
    handleCreateNote && handleCreateNote(inputMessage);
    setIsMessageCountShow(false);
    if (!textareaRef.current) return;
    setInputMessage('')
    textareaRef.current.value = '';
    setPlaying?.(true);
  }

  const handleUpdate = (noteId: string, message: string) => {
    handleUpdateNote && handleUpdateNote(noteId, message)
    setEditingNote('');
  }

  const handleQueueDelete = (noteId: string) => {
    setDeletingNotes([
      ...deletingNotes,
      {
        startCountTime: new Date(),
        waitingAPI: false,
        noteId
      }
    ])
  }

  const handleRestore = (noteId: string) => {
    setDeletingNotes([
      ...deletingNotes.filter((deletingNote) => deletingNote.noteId !== noteId)
    ])
  }

  const onFocusInput = () => {
    setPlaying?.(false);
  }

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (inputMessage.length === MAX_INPUT_MESSAGE_LENGTH && value.length >= MAX_INPUT_MESSAGE_LENGTH) return;
    setInputMessage(value.slice(0, MAX_INPUT_MESSAGE_LENGTH));
  }

  const handleClickNote = (note: Note) => {
    if (!editingNote) {
      handleSeek?.(note.time)
    }
  }

  function renderContent() {
    if (!currentModule) return;

    switch (currentModule.type) {
      case ModuleType.VIDEO:
        if (notes && notes.length === 0) {
          return (
            <>
              <S.EmptyContainer>
                <S.InfoText><FormattedMessage id="F012" values={{ br: <br/> }} /></S.InfoText>
              </S.EmptyContainer>
              <S.InputContainer>
                <S.InputBox
                  ref={textareaRef}
                  placeholder={intl.formatMessage({ id: 'F008' })}
                  onChange={handleChange}
                  value={inputMessage}
                />
                <S.InputToolBox>
                  {isMessageCountShow && <S.InputMessageCount>{inputMessage.length}/{MAX_INPUT_MESSAGE_LENGTH}</S.InputMessageCount>}
                  <S.InputSendButton onClick={handleCreate} disabled={inputMessage.length === 0}>
                    {inputMessage.length === 0 ? intl.formatMessage({ id: 'F009'}) : intl.formatMessage({ id: 'F009'})}
                  </S.InputSendButton>
                </S.InputToolBox>
              </S.InputContainer>
            </>
          )
        }

        return (
          <>
            <S.NotesContainer>
              {
                notes && notes.map((note) =>
                  <S.Note
                    key={note.id}
                    note={note}
                    isEditing={note.id === editingNote}
                    isDeleted={deletingNotes.map((deletingNote) =>
                      deletingNote.noteId).indexOf(note.id) !== -1
                    }
                    onClick={() => handleClickNote(note)}
                    setEditingNote={setEditingNote}
                    onSave={(nextMessage: string) => handleUpdate(note.id, nextMessage)}
                    onDelete={() => handleQueueDelete(note.id)}
                    onRestore={() => handleRestore(note.id)}
                  />
                )
              }
              {/* <pre>{JSON.stringify({deletingNotes, notes}, null, 2)}</pre> */}
            </S.NotesContainer>
            <S.InputContainer>
              <S.InputBox
                ref={textareaRef}
                placeholder={intl.formatMessage({ id: 'F008' })}
                onChange={handleChange}
                value={inputMessage}
                onFocus={onFocusInput}
                onKeyDown={e => e.stopPropagation()}
              />
              <S.InputToolBox>
                {isMessageCountShow && <S.InputMessageCount>{inputMessage.length}/{MAX_INPUT_MESSAGE_LENGTH}</S.InputMessageCount>}
                <S.InputSendButton onClick={handleCreate} disabled={inputMessage.length === 0}>
                  {inputMessage.length === 0 ? intl.formatMessage({ id: 'F009'}) : intl.formatMessage({ id: 'F009'})}
                </S.InputSendButton>
              </S.InputToolBox>
            </S.InputContainer>
          </>
        )
      case ModuleType.LAB:
        return (
          <S.EmptyContainer>
            <S.InfoText><FormattedMessage id="F013" values={{ br: <br/> }} /></S.InfoText>
          </S.EmptyContainer>
        )
      case ModuleType.QUIZ:
        return <>QUIZ</>
    }
  }

  if (noteError) {
    return (
      <S.EmptyContainer>
        <S.ErrorImage />
        <S.InfoText>出現暫時性的錯誤，請點此<S.RetryButton onClick={handleFetchNote}>重試</S.RetryButton></S.InfoText>
      </S.EmptyContainer>
    )
  }

  return (
    <S.Container>
      {renderContent()}
    </S.Container>
  );
}

export { NoteTab as default };
